export const when = (condition, value, fallback = null) => (condition ? value : fallback);
